const STORAGE_KEY = 'testAB'
  const ABTestManager = {
    getAll() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY)
        const parsed = JSON.parse(raw || '[]')
        return Array.isArray(parsed) ? parsed : []
      } catch {
        return []
      }
    },
    saveAll(tests) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(tests))
    },
    getVariant(testName) {
      const now = Date.now()
      const tests = this.getAll()
      const test = tests.find((t) => t.name === testName)
      if (!test) return null
      if (test.expiration && now > test.expiration) {
        this.removeTest(testName)
        return null
      }
      return test.value
    },
    async isExists(testName, expirationOrDays, variants, description, action) {
      try {
        const testABRaw = localStorage.getItem("testAB");
        let team = ""
        
        if (testABRaw) {
          const testAB = JSON.parse(testABRaw) || [];
      
          const found = testAB.find((item) => item.name === "buyButton_210525");
          if (found) {
            // console.log("Encontrado:", found);
            team = found.value
          } else {
            team = await ABTestManager.assignVariant(testName, expirationOrDays, variants, description, action);
            // console.log("Criado agora (dentro do array existente)");
          }
        } else {
          team = await ABTestManager.assignVariant(testName, expirationOrDays, variants, description, action);
          // console.log("Criado agora (novo array)");
        }
        return team;
      } catch (err) {
        console.error("Erro ao lidar com testAB:", err);
      }
    },
    setVariant(testName, expirationOrDays = 7, value, description, action) {
      const expiration =
        typeof expirationOrDays === 'number'
          ? Date.now() + expirationOrDays * 24 * 60 * 60 * 1000
          : new Date(expirationOrDays).getTime()
      const tests = this.getAll().filter((t) => t.name !== testName)
      tests.push({ name: testName, expiration, value, description, action })
      this.saveAll(tests)
      const dataTest = {
        "name": testName,
        "description": description,
        "variant": value,
        "action": action,
        "expires_at": expirationOrDays,
      }
      // console.log(dataTest, "<<<<< data aqui")
      Shopify.analytics?.publish?.("event_test_ab", { dataTest });
      this.clearExpiredTests();
    },

    setAction(testName) {
      const testAB = JSON.parse(localStorage.getItem("testAB")) || [];
        if(testAB) {
          const found = testAB.find((item) => item.name === "buyButton_210525");
        if(found) {
          const dataTest = {
            "name": found.name,
            "description": found.description,
            "variant": found.value,
            "action": found.action,
            "expires_at": new Date(found.expiration).toISOString(),
            "increment" : "action"
          }
          // console.log(dataTest, "<<<<< data aqui")
          Shopify.analytics?.publish?.("event_test_ab", { dataTest });
        }
      }
    },

    assignVariant(testName, expirationOrDays = 7, variants = ['A', 'B'], description, action) {
      const current = this.getVariant(testName)
      if (current) return current
      const value = variants[Math.floor(Math.random() * variants.length)]
      this.setVariant(testName, expirationOrDays , value, description, action)
      return value
    },
    removeTest(testName) {
      const tests = this.getAll().filter((t) => t.name !== testName)
      this.saveAll(tests)
    },
    clearExpiredTests() {
      const now = Date.now()
      const validTests = this.getAll().filter((t) => t.expiration > now)
      this.saveAll(validTests)
    },
  }
  
  // Exemplo de uso:
  // ABTestManager.isExists('buyButton_200525', 'A', 3) // 3 dias
  // ABTestManager.isExists('buyButton_210525', 'B', '2025-07-01T00:00:00Z') // data fixa